define((require) => {
    "use strict";

    const {extend} = require("underscore");
    const Class    = require("shared/util/Class");

    const NO_EXPERIENCE_SCHEDULED = {name: "No Experience"};
    const EMPTY_SLOT = {id: null, text: "-"};
    const EMPTY_SCHEDULED_SLOT = {
        text: "Empty Slot",
        children: [{
            id: NO_EXPERIENCE_SCHEDULED,
            text: "No Experience"
        }]
    };
    const PENDING_OPT_GROUP_RESULT = "---";

    // Private vars common to bookmarklet, snippet URL, and embed snippet...
    const location            = window.location;
    const host                = location.host;

    const BUNDLED_CHANNELS_URL  = `//${host + location.pathname}channels.`;
    const SNIPPET               = `${location.pathname}channels.js`;

    /**
     * All static utility class related to channel views (properties and setup) and Publish toolbar.
     * @class PublishUtil
     */
    return Class.extend({}, {

        /**
         * We need the customers to be able to take out the live content at a certain point in time.<p>
         *
         * Therefore, this no experience scheduled will be added to the "Next to go live" list.
         *
         * @type {{name: string}}
         */
        NO_EXPERIENCE_SCHEDULED,

        /**
         * Empty slot selection for a publishable.
         */
        EMPTY_SLOT,

        /**
         * Empty slot selection for a scheduled publishable.
         */
        EMPTY_SCHEDULED_SLOT,

        /**
         *  Name of the opt group used to indicate that pending results have been fetched.
         */
        PENDING_OPT_GROUP_RESULT,

        BUNDLED_CHANNELS_URL,

        SNIPPET,

        /**
         * Builds a JSON object for channels used when sending as property to Mix Panel channel related events.
         * @param {Object} payload Object containing mandatory properties for the tracking method.
         * @returns {Object} The event property to be sent to Mix Panel.
         */
        buildEventProperties(payload) {
            const {channel} = payload;

            const channelJson = channel.toJSON ? channel.toJSON() : channel;
            const experience = channelJson.experience;

            let eventProperties = {
                projectId: payload.projectId,
                triggerOrigin: payload.triggerOrigin,
                name: channelJson.name,
                url: channelJson.url,
                dragAndDrop: payload.dragAndDrop,
                manual: payload.manual
            };

            if (experience) {
                eventProperties = extend(eventProperties, {
                    experienceId: experience.id,
                    experienceVersion: experience.version,
                    experiencePushedVersion: experience.pushedVersion,
                    type: "experience"
                });
            }

            const group = channelJson.group;

            if (group) {
                eventProperties = extend(eventProperties, {
                    groupId: group.id,
                    groupVersion: group.version,
                    groupPushedVersion: group.pushedVersion,
                    groupType: group.type,
                    type: "group"
                });
            }

            const schedules = channelJson.schedules;

            if (schedules && schedules.length) {
                const schedule = schedules[0]; // we only support a single schedule.

                if (schedule.experience) {
                    eventProperties = extend(eventProperties, {
                        scheduledExperienceId: schedule.experience.id,
                        scheduledExperienceVersion: schedule.experience.version,
                        scheduledExperiencePushedVersion: schedule.experience.pushedVersion,
                        scheduledType: "experience"
                    });
                }

                if (schedule.group) {
                    eventProperties = extend(eventProperties, {
                        scheduledGroupId: schedule.group.id,
                        scheduledGroupVersion: schedule.group.version,
                        scheduledGroupPushedVersion: schedule.group.pushedVersion,
                        scheduledGroupType: schedule.group.type,
                        scheduledType: "group"
                    });
                }
            }

            return eventProperties;
        },

        /**
         * Returns the snippet URL based on the company's bundling strategy.
         *
         * @param {BundleStrategy} bundleStrategy The bundle strategy, e.g. <tt>BundleStrategy.Channels</tt>.
         * @param {Boolean} bundleStrategy.isBundled Whether the config is bundled.
         * @param {String} channelConfigId The `channelConfigId`.
         *
         * @returns {String} the snippet URL based on the company's bundling strategy
         */
        getSnippetUrl({isBundled}, channelConfigId) {
            let path = `//${host + SNIPPET}`;

            if (isBundled) {
                path = `${BUNDLED_CHANNELS_URL + channelConfigId}.js`;
            }

            // Note: by using "text/javascript", and not the correct "application/javascript", we ensure that
            // IE8 still works; it will not load scripts with "application/javascript"! The reason we should
            // be using "application" is to avoid the script being removed by clients using the (common) jQuery
            // Scrollpane plugin, which removes all script nodes inside the scroll pane with type
            // "text/javascript" or no type at all...

            return `<script type="text/javascript" data-channel="${channelConfigId}" src="${path}"></script>`;
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/PublishUtil.js